/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Account Cashback History Table cells configuration
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { EColumnCell, EColumnFilter } from '../../../../components/Table/types/columnTypes';
import { CashbackHistoryTableField } from '../../types/cashbackHistoryTypes';

export const CashbackTableCellConfig: { [key in CashbackHistoryTableField]: number } = {
    [CashbackHistoryTableField.date]: 380,
    [CashbackHistoryTableField.operationType]: 210,
    [CashbackHistoryTableField.scores]: 160,
    [CashbackHistoryTableField.service]: 180,
};

export const CashbackTableNames: CashbackHistoryTableField[] = [
    CashbackHistoryTableField.operationType,
    CashbackHistoryTableField.service,
    CashbackHistoryTableField.scores,
    CashbackHistoryTableField.date,
];

export const getCashbackTableColumnFilterType = (name: string) => {
    switch (name) {
        case CashbackHistoryTableField.operationType:
        case CashbackHistoryTableField.service:
            return EColumnFilter.filterMultiSelect;
        case CashbackHistoryTableField.date:
            return EColumnFilter.filterDate;
        case CashbackHistoryTableField.scores:
            return EColumnFilter.filterRange;
        default:
            return '';
    }
};

export const getCashbackTableColumnCellType = (name: string): string => {
    switch (name) {
        case CashbackHistoryTableField.date:
            return EColumnCell.createDate;
        case CashbackHistoryTableField.scores:
            return EColumnCell.score;
        default:
            return EColumnCell.text;
    }
};
